import { createFileRoute } from '@tanstack/react-router'
import { internalEmailSearchSchema } from '@/features/filter-internal-emails/model/internalEmailSearch'
import { InternalEmailsPage } from '@/pages/internal-emails/ui/InternalEmailsPage'

export const Route = createFileRoute('/emails')({
  validateSearch: internalEmailSearchSchema,
  component: InternalEmailsPage,
})
